<script lang="ts">
	import { DefaultButton, DefaultEmailInput, Modal, ModalHeader, recommendToFriend, validateEmail } from '@enzianweb/shared';
	import { _ } from 'svelte-i18n';

	let email: string = $state('');
	let valid = $derived(validateEmail(email));

	interface Props {
		onModalClose: () => void;
	}

	let { onModalClose }: Props = $props();

	async function sendRecommendMail() {
		//Send the request
		await recommendToFriend({ targetMail: email });
		//Close the modal
		onModalClose();
	}
</script>

<Modal {onModalClose}>
	{#snippet header()}
		<ModalHeader text={$_('recommend.lbl_header')} />
	{/snippet}
	{#snippet content()}
		<div style="width: 640px;" class="flex flex-col gap-4">
			<p class="text-normal-bold">{$_('header.recommend.lbl_header')}</p>

			<p>{$_('header.recommend.lbl_body')}</p>

			<div class="flex justify-center">
				<img
					src="https://enzianimages.s3.eu-central-2.amazonaws.com/beer.webp"
					alt="beer"
					width="528"
					height="269"
				/>
			</div>

			<p class="text-small">{$_('header.recommend.lbl_none-alc')}</p>

			<DefaultEmailInput
				placeholder={$_('header.recommend.input_email')}
				propertyName="email"
				bind:value={email}
			></DefaultEmailInput>
		</div>
	{/snippet}
	{#snippet footer()}
		<div>
			<!-- Buttons -->
			<div class="flex justify-end gap-4">
				<DefaultButton secondary={true} onClick={onModalClose} text={$_('general.lbl_cancel')} />
				<DefaultButton
					disabled={!valid}
					spamProtectedCall={sendRecommendMail}
					text={$_('recommend.lbl_recommend')}
				/>
			</div>
		</div>
	{/snippet}
</Modal>
